import { FETCH_ADVERTISERS } from "../actions/types";

export const advertisersReducer = (state = [], action) => {
  switch (action.type) {
    case FETCH_ADVERTISERS:
      let advertisers = action.payload;
      if (advertisers.length > 1)
        advertisers = advertisers.sort((a, b) => {
          if (a.displayName.toLowerCase() > b.displayName.toLowerCase())
            return 1;
          if (b.displayName.toLowerCase() > a.displayName.toLowerCase())
            return -1;
          return 0;
        });
      return advertisers;
    default:
      return state;
  }
};
